module.exports = __webpack_public_path__ + "img/portrait-025.ba94bb67.jpg";